import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import LogoCaldenMobilePos from "../images/logoCaldenMobilePOSv2.png";
import KeyIcon from "@mui/icons-material/Key";
import PersonIcon from "@mui/icons-material/Person";
import DnsIcon from "@mui/icons-material/Dns";
import Conexion from "../api/conexion";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Footer from "../components/Footer";
import banderas from "../api/banderas";
import estacion from "../api/estacion";
import limiteAfip from "../api/limiteAfip";
import tarjetas from "../api/tarjetas";
import talonarioQR from "../api/talonarioQR";
import passEmpleado from "../api/empleado";
import apiErrorHandler from "../helpers/apiErrorHandler"; // Importa el helper
import puestos from "../api/puestos";
import qrs from "../api/qr";
import configuracionIntegracionesFULL from "../api/configuracionIntegracionesFULL";
import { guardarTalonarios } from "../helpers/guardarTalonariosHelper";
import { requestSerialNumber, setStatusBarColor } from "../helpers/nativeInterface";

const Login = () => {
  const [showAlert, setShowAlert] = useState({
    open: false,
    type: "errorCamposVacios",
  });
  const [formattedNic, setFormattedNic] = useState("");
  const [user, setUser] = useState("AONIKEN");
  const [password, setPassword] = useState("AONIKEN");
  const [nic, setNic] = useState("EXPO:2025");
  const [imageWidth, setImageWidth] = useState(400);
  const [cardMaxWidth, setCardMaxWidth] = useState(400);
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [serialNumberKeyClover, setSerialNumberKeyClover] = useState("");
  var estacionData = "";

  // Efecto para manejar el resize de la ventana
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
      console.log("Width:", window.innerWidth, "Height:", window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Valores hardcodeados por defecto
  const DEFAULT_PUESTO_INDEX = windowWidth < 700 ? 0 : 4; // Primer puesto del array (OFICINAPLAYA1)
  const DEFAULT_PREFIJO = "55";
  const DEFAULT_QR_POSITION = "1";

  // Función para configurar valores por defecto después del login
  const configurarValoresPorDefecto = async () => {
    try {
      // Obtener y configurar puestos
      const allPuestos = await puestos.getPuestos();
      localStorage.setItem("puestosArray", JSON.stringify(allPuestos));

      // Configurar puesto por defecto
      if (allPuestos.length > 0) {
        const puestoDefault = allPuestos[DEFAULT_PUESTO_INDEX];
        localStorage.setItem("puesto", JSON.stringify(puestoDefault));

        // Configurar datos del puesto por defecto
        const cantidadPlayerosSolicitados = puestoDefault.caja?.cantidadPlayerosSolicitados || 0;
        const solicitarAforadores = puestoDefault.caja?.solicitarAforadores || false;
        const perteneceFULL = puestoDefault.talonarios[0]?.perteneceFULL || false;

        localStorage.setItem("cantidadPlayerosSolicitados", cantidadPlayerosSolicitados);
        localStorage.setItem("solicitarAforadores", solicitarAforadores);
        localStorage.setItem("idCaja", puestoDefault.caja?.idCaja || "");
        localStorage.setItem("perteneceFULL", perteneceFULL);
        localStorage.setItem("combustiblesSoloPorDespachos", puestoDefault.combustiblesSoloPorDespachos);
        localStorage.setItem("nombreCaja", puestoDefault.caja?.descripcion || "");

        try {
          const habilitarFacturacionArticulosFullPlaya = await configuracionIntegracionesFULL.getConfiguracionIntegracionesFULL();
          localStorage.setItem("habilitarFacturacionArticulosFullPlaya", habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya);
          const bandera = localStorage.getItem("bandera");
          const habilitaTiendaFull =
            (bandera === "ypf" || bandera === "sinBandera") && perteneceFULL && (!solicitarAforadores || habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya);
          localStorage.setItem("habilitaTiendaFull", habilitaTiendaFull);
        } catch (error) {
          console.log("Error obteniendo configuración FULL, usando valores por defecto");
          localStorage.setItem("habilitarFacturacionArticulosFullPlaya", false);
          localStorage.setItem("habilitaTiendaFull", false);
        }

        guardarTalonarios(puestoDefault);
      }

      // Configurar prefijo por defecto
      localStorage.setItem("prefijoFront", DEFAULT_PREFIJO);

      // Obtener y configurar QRs
      try {
        const qrsEstacion = await qrs.getQRs();
        const qrsOrdenados = qrsEstacion.sort((a, b) => a.posi - b.posi);
        localStorage.setItem("qrsArray", JSON.stringify(qrsOrdenados));

        // Configurar posición QR por defecto
        if (qrsOrdenados.length > 0) {
          const qrDefault = qrsOrdenados.find(qr => qr.posi === parseInt(DEFAULT_QR_POSITION)) || qrsOrdenados[0];
          localStorage.setItem("idPosicionQR", qrDefault.posi.toString());
          localStorage.setItem("urlPosicionQR", qrDefault.url);
        }
      } catch (error) {
        console.log("Error obteniendo QRs, usando valores por defecto");
        localStorage.setItem("idPosicionQR", DEFAULT_QR_POSITION);
        localStorage.setItem("urlPosicionQR", `https://qr-default-url-${DEFAULT_QR_POSITION}.com`);
      }

      // Configurar switches por defecto
      localStorage.setItem("isQRSwitchOn", JSON.stringify(true)); // QR individual por defecto
      localStorage.setItem("conListadoQR", false);
      localStorage.setItem("useTips", JSON.stringify(false));
      localStorage.setItem("useCashback", JSON.stringify(false));

      console.log("Valores por defecto configurados exitosamente");
    } catch (error) {
      console.log("Error configurando valores por defecto:", error);
    }
  };

  // Código a usar para la parte de Serial Key Clover
  useEffect(() => {
    const handleSerialNumberObtained = event => {
      const serialNumber = event.detail;
      setSerialNumberKeyClover(serialNumber);
      localStorage.setItem("serialNumberKeyClover", serialNumber);
    };

     if (!localStorage.getItem("serialNumberKeyClover")) {
      localStorage.setItem("serialNumberKeyClover", "NCCC05643798");
       }

    // alert(localStorage.getItem("serialNumberKeyClover"));
    // Verifica si la función existe antes de intentar llamarla
    if (!requestSerialNumber()) {
      console.warn("La función obtenerSerialClover no está disponible.");
    }

    window.addEventListener("serialNumberObtained", handleSerialNumberObtained);

    return () => {
      window.removeEventListener("serialNumberObtained", handleSerialNumberObtained);
    };
  }, []);

  useEffect(() => {
    if (!setStatusBarColor("#0057B8")) {
      console.warn("MyInterface no está disponible");
    }
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  const toggleAlert = type => {
    setShowAlert({ open: true, type });
  };

  const handleNicChange = event => {
    setNic(event.target.value);
  };

  const handleUserChange = event => {
    setUser(event.target.value);
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
  };

  const handleLogin = async () => {
    if (password === "" || user === "" || nic === "") {
      toggleAlert("errorCamposVacios");
    } else {
      setIsLoading(true); // Set loading to true before making the request

      const formattedNic = Conexion.formatearNIC(nic);
      localStorage.setItem("formattedNic", formattedNic);
      setFormattedNic(formattedNic);
      const userData = { nombre: user, password: password, nic: formattedNic };
      try {
        const response = await Conexion.validarUsuario(userData);

        if (response.status === 500) {
          toggleAlert("errorUser");
        } else {
          if (rememberMe) {
            localStorage.setItem("user", response.data.nombre);
            localStorage.setItem("nic", nic);
          } else {
            localStorage.removeItem("user");
            localStorage.removeItem("nic");
          }
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user", response.data.nombre);

          // Obtener el token es exitoso, ahora obtener las banderas
          try {
            const limite = await limiteAfip.getLimiteAfip(); // Obtain the limit data
            localStorage.setItem("limite", limite);

            const banderasData = await banderas.getBanderas();
            localStorage.setItem("bandera", "point");

            estacionData = await estacion.getEstacion();
            var estacionDataJSON = JSON.stringify(estacionData);
            localStorage.setItem("estacionData", estacionDataJSON);

            const talonarioQRInfo = await talonarioQR.getIdTalonarioQR();
            localStorage.setItem("idTalonarioQR", talonarioQRInfo.data.idTerminalTarjeta);

            const passEmpleados = await passEmpleado.getEmpleado();
            localStorage.setItem("passEmpleados", JSON.stringify(passEmpleados.data));

            const tarjetasData = await tarjetas.getTarjetas();
            localStorage.setItem("tarjetas", JSON.stringify(tarjetasData));

            // Configurar valores hardcodeados por defecto después del login
            await configurarValoresPorDefecto();

            const bandera = localStorage.getItem("bandera");

            const colorsByBandera = {
              shell: "#FBCE07",
              ypf: "#005090",
              axion: "#101760",
              puma: "#00784A",
              gulf: "#002776",
              refinor: "#B6D70B",
              dapsa: "#E01C24",
              voy: "#9F1857",
              point: "#FFE600",
            };

            if (!setStatusBarColor(colorsByBandera[bandera] || "#000000")) {
              console.warn("MyInterface no está disponible");
            }

            window.location.replace("/"); // Redirigir a la página de inicio
          } catch (error) {
            localStorage.removeItem("formattedNic");
            localStorage.removeItem("token");
            apiErrorHandler(error, { stopFlow: true });
          }
        }
      } catch (error) {
        localStorage.removeItem("formattedNic");
        localStorage.removeItem("token");
        toggleAlert("errorUser");
        setIsLoading(false);
      }
    }
  };

  const handleRememberMeChange = event => {
    setRememberMe(event.target.checked);
    if (!rememberMe) {
      localStorage.setItem("rememberMe", true);
    } else {
      localStorage.setItem("rememberMe", false);

      console.log("entro aca si NO quiero recordar");
    }
  };

  const updateDimensions = () => {
    const screenWidth = window.innerWidth;
    setImageWidth(screenWidth < 700 ? 300 : 250);
    setCardMaxWidth(windowHeight>1000? 700 : screenWidth < 700 ? 400 : 400);
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedNic = localStorage.getItem("nic");
    const storedRememberMe = localStorage.getItem("rememberMe");
    if (storedRememberMe === "true") {
      setRememberMe(true);
      // setUser(storedUser);  // Comentado para mantener valores hardcodeados
      // setNic(storedNic);    // Comentado para mantener valores hardcodeados
    }

    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  const cardStyle = {
    // margin: "0 auto",
    width: "100%",
    maxWidth: `${cardMaxWidth}px`,
    backgroundColor: "#009281",
    boxShadow: 0,
    padding: 1,
  };

  const inputStyle = {
    marginTop: -3,
    marginBottom: -60,
    // marginBottom: 0,
    backgroundColor: "white",
    borderRadius: 3,
    '& .MuiInputBase-input': {
      fontSize: windowHeight > 1000 ? '1.5rem' : '1rem',
      padding: windowHeight > 1000 ? '20px 14px' : '16.5px 14px',
    },
    '& .MuiInputBase-root': {
      fontSize: windowHeight > 1000 ? '1.5rem' : '1rem',
    },
  };

  const backgroundStyle = {
    backgroundColor: "#009281",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  return (
    <div style={backgroundStyle}>
      <img src={LogoCaldenMobilePos} alt="Logo Calden Oil" style={{ width: windowHeight>1000?"550px":"280px", height: "auto", ...(windowHeight > 1000 && {marginTop: "15rem"}) }} />

      {isLoading ? (
        // Display CircularProgress while isLoading is true
        <CircularProgress sx={{ marginTop: "7rem" }} color="primary" />
      ) : (
        <Card sx={cardStyle}>
          <CardContent sx={{ marginTop: -6 }}>
            <h4 style={{ color: "#fff", paddingBottom: "2px", ...(windowHeight > 1000 && { fontSize: "1.8rem" }) }}> NIC</h4>
            <TextField
              fullWidth
              type="text"
              value={nic}
              placeholder="Ingrese el NIC"
              sx={inputStyle}
              onChange={handleNicChange}
              InputProps={{
                readOnly: true,
                startAdornment: <DnsIcon sx={{ marginRight: "5px", color: "#00427f", fontSize: windowHeight > 1000 ? "2rem" : "1.5rem" }} />,
              }}
            />
            <h4 style={{ color: "#fff", paddingBottom: "2px", ...(windowHeight > 1000 && { fontSize: "1.8rem" }) }}> USUARIO</h4>
            <TextField
              fullWidth
              type="text"
              value={user}
              placeholder="Ingrese su usuario"
              sx={inputStyle}
              onChange={handleUserChange}
              InputProps={{
                readOnly: true,
                startAdornment: <PersonIcon sx={{ marginRight: "5px", color: "#00427f", fontSize: windowHeight > 1000 ? "2rem" : "1.5rem" }} />,
              }}
            />
            <h4 style={{ color: "#fff", paddingBottom: "2px", ...(windowHeight > 1000 && { fontSize: "1.8rem" }) }}>CONTRASEÑA</h4>
            <TextField
              fullWidth
              type={showPassword ? "text" : "password"}
              variant="outlined"
              value={password}
              placeholder="Ingrese su contraseña"
              onChange={handlePasswordChange}
              InputProps={{
                readOnly: true,
                startAdornment: <KeyIcon sx={{ marginRight: "5px", color: "#00427f", fontSize: windowHeight > 1000 ? "2rem" : "1.5rem" }} />,
                endAdornment: (
                  <IconButton onClick={togglePasswordVisibility} sx={{ color: "#00427f", padding: windowHeight > 1000 ? "12px" : "8px" }}>
                    {showPassword ? <VisibilityOff sx={{ fontSize: windowHeight > 1000 ? "2rem" : "1.5rem" }} /> : <Visibility sx={{ fontSize: windowHeight > 1000 ? "2rem" : "1.5rem" }} />}
                  </IconButton>
                ),
              }}
              sx={{
                ...inputStyle,
                fontWeight: "bold",
              }}
            />

            <Box sx={{ display: "flex", flexDirection: "row-reverse", ...(windowHeight > 1000&&{marginTop:5}) }}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: 15,
                  marginTop: 1,
                }}
              >
                <Checkbox
                  checked={rememberMe}
                  onChange={handleRememberMeChange}
                  sx={{
                    "&.Mui-checked": {
                      color: "#fff", // Cambia el color del tilde a blanco
                    },
                    color: "#fff",
                    transform: windowHeight > 1000 ? "scale(1.5)" : "scale(1)",
                  }}
                />

                <span style={{ color: "#fff", marginLeft: -4, fontWeight: "bold", fontSize: windowHeight > 1000 ? "18px" : "12px" }}>RECORDAR</span>
              </label>
            </Box>

            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <Button
                variant="contained"
                sx={{
                  border: 1,
                  borderRadius: 2,
                  fontWeight: "bold",
                  backgroundColor: "#00427f",
                  ":hover": {
                    backgroundColor: "#00427f",
                  },
                  fontSize: windowHeight > 1000 ? 28 : 20,
                  padding: windowHeight > 1000 ? '16px 32px' : '8px 16px',
                  marginBottom: -2,
                }}
                onClick={handleLogin}
              >
                INGRESAR
              </Button>
            </div>
          </CardContent>
        </Card>
      )}

      <Dialog
        open={showAlert.open}
        onClose={() => setShowAlert({ open: false, type: null })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Error</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {showAlert.type === "errorCamposVacios"
              ? "Complete todos los campos"
              : showAlert.type === "errorUser"
              ? "Usuario o contraseña incorrectos"
              : showAlert.type === "errorConexion"
              ? `No se pudo conectar al host ${formattedNic}`
              : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAlert({ open: false, type: null })} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </div>
  );
};

export default Login;
